module.exports = __webpack_public_path__ + "img/2024-12_powerhouse.fc480c68.jpg";